exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "#useCarRules {\n  padding: 0.17rem 0.17rem 1rem 0.17rem;\n}\n#useCarRules p {\n  color: #1E283C;\n  font-size: 0.16rem;\n}\n#useCarRules .serial-number {\n  float: left;\n  width: 0.2rem;\n}\n#useCarRules .content {\n  overflow: hidden;\n}\n#useCarRules .top {\n  -ms-flex-align: center;\n      align-items: center;\n  text-align: center;\n  font-size: 0.14rem;\n}\n#useCarRules .top time {\n  -ms-flex-align: center;\n      align-items: center;\n  text-align: center;\n  font-size: 0.14rem;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/less-loader/dist/cjs.js?{"modifyVars":{"@brand-primary":"#1DA57A","@primary-button-fill":"#1DA295"}}!./src/staticPage/useCarRules/index.less
// module id = 322
// module chunks = 0